/* Beauten Shopify bridge: wishlist (localStorage), cart count, AJAX add-to-cart */
(function () {
  'use strict';

  /* ---------- Wishlist (localStorage) ---------- */
  var WISH_KEY = 'bt_wishlist';
  function getWish() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; }
  }
  function setWish(list) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {}
  }
  document.querySelectorAll('.bt-wishlist-btn').forEach(function (btn) {
    var handle = btn.dataset.productHandle;
    if (handle && getWish().indexOf(handle) !== -1) btn.classList.add('is-active');
    btn.addEventListener('click', function () {
      var list = getWish();
      var i = list.indexOf(handle);
      if (i === -1) { list.push(handle); btn.classList.add('is-active'); }
      else { list.splice(i, 1); btn.classList.remove('is-active'); }
      setWish(list);
    });
  });

  /* ---------- Cart count ---------- */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('#CartCount').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }
  document.addEventListener('DOMContentLoaded', refreshCartCount);

  /* ---------- AJAX add-to-cart for card forms ---------- */
  document.querySelectorAll('.bt-add-to-cart-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      var label = btn ? btn.querySelector('.text') : null;
      var original = label ? label.textContent : '';
      if (label) label.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(form.querySelector('input[name="id"]').value, 10), quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          if (label) label.textContent = 'Added ✓';
          refreshCartCount();
          setTimeout(function () { if (label) label.textContent = original; }, 1500);
        })
        .catch(function () {
          form.submit(); /* fall back to standard form post */
        });
    });
  });
})();
